import script from "./ChipButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChipButton.vue?vue&type=script&setup=true&lang=ts"

import "./ChipButton.vue?vue&type=style&index=0&id=508840f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508840f0"]])

export default __exports__